import React from 'react';
import { IconAlertTriangle, IconCircleCheck, IconRefresh } from '@tabler/icons-react';
interface OverwriteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOverwrite: () => void;
  onKeepCompleted: () => void;
}
export function OverwriteConfirmationModal({
  isOpen,
  onClose,
  onOverwrite,
  onKeepCompleted
}: OverwriteConfirmationModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-yeppy-text bg-opacity-20 backdrop-blur-sm" data-id="element-246">
      <div className="bg-white rounded-yeppy w-full max-w-md p-6 shadow-xl animate-in fade-in zoom-in duration-200" data-id="element-247">
        <div className="flex flex-col items-center text-center" data-id="element-248">
          <div className="w-12 h-12 rounded-full bg-yeppy-text bg-opacity-10 flex items-center justify-center mb-4 mx-auto" data-id="element-249">
            <IconAlertTriangle className="w-6 h-6 text-yeppy-text" stroke={1.5} data-id="element-250" />
          </div>

          <h3 className="font-rubik font-bold text-xl text-yeppy-text mb-2" data-id="element-251">
            Modifica Attività
          </h3>

          <p className="font-poppins text-yeppy-text text-opacity-70 mb-6" data-id="element-252">
            Hai già completato alcune attività in questa lista. Come vuoi
            procedere con le modifiche?
          </p>

          <div className="flex flex-col gap-3 w-full" data-id="element-253">
            <button onClick={onKeepCompleted} className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-poppins text-sm font-semibold transition-colors bg-yeppy-text text-white active:scale-[0.98]" data-id="element-254">
              <IconCircleCheck className="w-5 h-5" stroke={1.5} data-id="element-255" />
              Mantieni completate
            </button>

            <button onClick={onOverwrite} className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-poppins text-sm font-semibold transition-colors bg-white border border-yeppy-text border-opacity-20 text-yeppy-text active:scale-[0.98]" data-id="element-256">
              <IconRefresh className="w-5 h-5" stroke={1.5} data-id="element-257" />
              Sovrascrivi tutto
            </button>

            <button onClick={onClose} className="mt-2 text-sm font-poppins text-yeppy-text text-opacity-50 transition-colors" data-id="element-258">
              Annulla
            </button>
          </div>
        </div>
      </div>
    </div>;
}